import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import GenericTouchable from './GenericTouchable';
const TouchableWithoutFeedback = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(GenericTouchable, {
  ref: ref,
  ...props
}));
TouchableWithoutFeedback.defaultProps = GenericTouchable.defaultProps;
TouchableWithoutFeedback.propTypes = GenericTouchable.publicPropTypes;
export default TouchableWithoutFeedback;